import { TokenUtil } from 'services/TokenUtil';

export const masqueradeExit = async (): Promise<void> => {
  // Restore tokens
  TokenUtil.restoreTokens();
  // Remove backup tokens
  TokenUtil.removeBackupTokens();
};
